export class IntervaloDeTempo {
  nome: string;
  dataHoraInicio: Date;
  dataHoraTermino: Date;  
}
